import { Ionicons, FontAwesome } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import * as Linking from 'expo-linking';
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';
import firebase from 'firebase';
import 'firebase/firestore';
import Moment from 'moment';
import React from 'react';
import { ActivityIndicator, Alert, Dimensions, FlatList, Image, Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { TextInput, Card, Checkbox, FAB } from 'react-native-paper';
import Dialog, { DialogContent, DialogTitle, SlideAnimation } from 'react-native-popup-dialog';
//import StarRating from 'react-native-star-rating';
import StepIndicator from 'react-native-step-indicator';
import { updateProfile, updateStore } from '../actions/stores';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CLoading } from '../components/StyledText';
import Colors from '../constants/Colors';
import Cstyles from '../constants/Cstyles';
import { sendPushNotif, getStoreInfo } from '../helper';


let containerCount = 0;

class CellContainer extends React.Component {
  constructor(args) {
    super(args);
    this._containerId = containerCount++;

  }
  render() {
    return <View {...this.props}>{this.props.children}{/*<Text>Cell Id: {this._containerId}</Text>*/}</View>;
  }
}

class OrderDetails extends React.Component {


  labels = ["Order Received ", "In Process", "Dispatched", "Delivered", "Complete"];
  customStyles = {
    stepIndicatorSize: 25,
    currentStepIndicatorSize: 30,
    separatorStrokeWidth: 2,
    currentStepStrokeWidth: 3,
    stepStrokeCurrentColor: '#fe7013',
    stepStrokeWidth: 3,
    stepStrokeFinishedColor: '#fe7013',
    stepStrokeUnFinishedColor: '#aaaaaa',
    separatorFinishedColor: '#fe7013',
    separatorUnFinishedColor: '#aaaaaa',
    stepIndicatorFinishedColor: '#fe7013',
    stepIndicatorUnFinishedColor: '#ffffff',
    stepIndicatorCurrentColor: '#ffffff',
    stepIndicatorLabelFontSize: 10,
    currentStepIndicatorLabelFontSize: 13,
    stepIndicatorLabelCurrentColor: '#fe7013',
    stepIndicatorLabelFinishedColor: '#ffffff',
    stepIndicatorLabelUnFinishedColor: '#aaaaaa',
    labelColor: '#999999',
    labelSize: 10,
    currentStepLabelColor: '#fe7013'
  };
  constructor(args) {
    super(args);
    this.unsubscribe = null;
    let { width } = Dimensions.get("window");
    this.state = {
      isLoading: true,
      scrWidth: (width * 0.70),
      currency: '',
      total: 0,
      totalPayable: 0,
      totalPayableWithoutDelivery: 0,
      discount: 0,
      emptyCart: false,
      Coupon: '',
      errors: {},
      customer: '',
      CustomerName: '',
      CustomerId: '',
      printing: false,
      PlacedAt: '',
      orderId: '0',
      currentPosition: 2,
      Dialogvisible: false,
      DialogContent: '',
      DialogTitle: '',
      DialogUpdButton: false,
      DialogUpdButtonText: '',
      ShipService: '',
      ShipTracking: '',
      DialogLoading: false,
      DispDttm: '',
      DeliveredTo: '',
      DeliveredDttm: '',
      PaymentRef: '',
      PymntStatus: false,
      CompletionNotes: '',
      CompletedDttm: '',
      html: '',
      profileData: null,
      gradStart: Colors.gradStart,
      gradEnd: Colors.gradEnd,
      Feedback: '',
      DeliveryCharge: 0,
      labels: ["Order Received ", "In Process", "Ready", "Picked Up", "Complete"]
    };
  }



  setHeaderButtons() {
    let storeData = this.state.storeData
    this.props.navigation.setOptions({
      title: this.props.route.params.storeId ? storeData.storeName : 'Order Details',
      headerRight: () => (
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          {storeData.sharePhone ? <TouchableOpacity style={{ padding: 10, marginRight: 10 }}
            onPress={() => this._storeInquiry()}>
            <Ionicons name={Platform.OS === "ios" ? "logo-whatsapp" : "logo-whatsapp"} size={20} color={'white'}
            /></TouchableOpacity> : null}
          {((!this.state.Accepted) || this.state.OrderStatus == 'Pending') && (this.state.OrderStatus != 'Cancelled') ? <TouchableOpacity style={{ padding: 10 }}
            onPress={() => this.cancelOrder()}>
            <Ionicons name={Platform.OS === "ios" ? "ios-close-circle-outline" : "md-close-circle-outline"} size={20} color={'white'}
            /></TouchableOpacity> : null}
          {!this.state.PymntStatus && (this.state.OrderStatus != 'Cancelled' && this.state.Accepted != false) ? <TouchableOpacity style={{ padding: 10 }}
            onPress={() => this.makePayment()}>
            <Ionicons name={Platform.OS === "ios" ? "ios-card" : "md-card"} size={20} color={'white'}
            /></TouchableOpacity> : null}
          {(this.state.OrderStatus != 'Pending' && (this.state.OrderStatus != 'Cancelled' && this.state.Accepted != false)) || this.state.PymntStatus ? <TouchableOpacity style={{ padding: 10 }}
            onPress={() => this.printToPdfWeb()}>
            <Ionicons name={Platform.OS === "ios" ? "ios-print" : "md-print"} size={20} color={'white'}
            /></TouchableOpacity> : null}
        </View>
      ),
    });
  }
  async printToPdf() {
    this.setState({ isLoading: true, printing: 'Printing Invoice...' });
    const response = await Print.printToFileAsync({ 'html': this.state.html + this.state.custhtml + this.state.htmlend }).then(() =>
      this.setState({ isLoading: false, printing: null })
    ).catch(() => this.setState({ isLoading: false, printing: null }));

  }

  async printToPdfWeb() {
    //console.log(this.state.html + this.state.custhtml + this.state.htmlend)
    var newWindow = window.open();
    newWindow.document.write(this.state.html + this.state.custhtml + this.state.htmlend);
    setTimeout(() => {
      //Wait for images to load before printing
      newWindow.print()
    }, 5000);

  }
  _storeInquiry() {
    let storeData = this.props.store.store;
    let phoneNumber = storeData.sharePhone ? (storeData.loginPhone ? storeData.loginPhone : storeData.phone ? (storeData.countrycode ? storeData.countrycode : '') + '' + storeData.phone : null) : null;
    Linking.openURL('whatsapp://send?phone=' + phoneNumber + '&text=' + ('I need some information about the order ' + this.state.PlacedAt.toString().slice(-4)).replace("'", "") + ' placed through Store My Store app on ' + Moment(this.state.PlacedAt).format('DD-MMM-YYYY'));

  }
  async cancelOrder() {
    if (!this.state.pendingAcceptance) {
      if (this.state.Accepted == false) {
        alert('This order was already declined. Cannot be cancelled');
      } else if (this.props.route.params.OrderStatus == 'Pending') {
        this.setState({ DialogContent: 'Cancel', DialogTitle: 'Cancel Order', DialogUpdButtonText: 'Cancel Order', DialogUpdButton: true });
        this.ShowDialog();
      } else {
        if (this.state.OrderStatus == "Cancelled") {
          alert('Order already cacelled');
        } else {
          alert('Dispatched orders cannot be cancelled');
        }

      }
    } else {
      this.setState({ DialogContent: 'Cancel', DialogTitle: 'Cancel Order', DialogUpdButtonText: 'Cancel Order', DialogUpdButton: true });
      this.ShowDialog();
    }

  }

  async shareInvoice() {
    this.setState({ isLoading: true, printing: true });
    await Print.printToFileAsync({ 'html': this.state.html }).then((response) => {
      Sharing.shareAsync(response.uri,);
      this.setState({ isLoading: false, printing: false })
    });


  }


  onStarRatingPress(rating, data) {

    let tempList = this.state.itemsList;
    tempList[data.index].starCount = rating;

    this.setState({
      itemsList: tempList
    });
    firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).collection('items').doc(data.id).update({ starCount: rating });
    this.setState({ DialogContent: 'Rating', RatingItem: data.ItemName, RatingItemId: data.id, Feedback: data.Feedback, DialogTitle: 'Rate the product', DialogUpdButtonText: 'Update', DialogUpdButton: true });
    this.ShowDialog();




  }

  _updateRating() {
    firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).collection('items').doc(this.state.RatingItemId).update({ Feedback: this.state.Feedback }).then(() => {
      this.setState({ DialogLoading: false });
    });

  }

  async makePayment() {
    if (this.state.PymntStatus) {
      Alert.alert(
        'Already Paid',
        "The payment for this order has already been completed",
        [

          { text: 'Got it', onPress: () => null },
        ]
      );
    } else {
      if (this.props.profile_data.profile_data && this.props.profile_data.profile_data.uid) {
        this.props.navigation.navigate('PaymentScreen2', { payAmount: this.state.totalPayable, currency: 'INR', gradStart: this.state.gradStart, gradEnd: this.state.gradEnd, onPaymentComplete: this._updatePayStatus, source: 'OrderDetails', orderId: this.state.PlacedAt.toString().slice(-4) })
      } else {
        this.props.navigation.navigate('Profile', { goback: true })
      }

    }



  }

  _updatePayStatus = async (payRef, payMethod, payStatus) => {
    let that = this;

    let promise = new Promise((res, rej) => {
      if (payMethod == 'UPI') {
        //Dont update status as UPI does not capture status in Expo
        res(this.state.PlacedAt.toString().slice(-4))
      } else {
        firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).update({ PymntStatus: payStatus, Completed: this.state.Status == 'Complete' ? payStatus : false, PaymentDttm: firebase.firestore.FieldValue.serverTimestamp(), UpdateDttm: firebase.firestore.FieldValue.serverTimestamp(), PaymentRef: payRef, PymntMthd: payMethod }).then(() => {
          that.setState({ PymntStatus: payStatus, PaymentRef: payRef })
          res(this.state.PlacedAt.toString().slice(-4))
        })
      }
    })
    let result = await promise;
    return result
  }



  async componentDidMount() {
    console.log('Order Details');

    const { route } = this.props;
    console.log(route.params)
    let storeData = this.props.store.store;
    let storeId = null;
    let orderId = null;
    if (!route.params) {

      Linking.getInitialURL().then(async (initialUrl) => {
        if (initialUrl) {
          let { path, queryParams } = Linking.parse(initialUrl);

          if (queryParams && queryParams.s && queryParams.o) {
            storeId = queryParams.s
            orderId = queryParams.o
            storeData = await getStoreInfo(storeId)
            this.props.updateStore(storeData);
            this.loadOrder(storeData, orderId)

          } else {
            this.setState({ storeName: 'Oops! The link seems to be broken' })
            this.props.navigation.navigate('Not Found')
          }
        }
      })
    } else {
      //Opened from Orders page
      this.loadOrder(storeData, route.params.orderId)
      console.log(route.params.orderId)
    }



  }

  loadOrder(storeData, orderId) {

    this.props.navigation.setOptions({
      headerStyle: {
        backgroundColor: storeData.gradStart, //Set Header color
      },
      headerTintColor: 'white'
    })
    let profile_data = this.props.profile_data.profile_data;
    this.setState({ storeId: storeData.id, profile_data, storeData, gradStart: storeData.gradStart ? storeData.gradStart : this.state.gradStart, gradEnd: storeData.gradEnd ? storeData.gradEnd : this.state.gradEnd });
    if (storeData.gradStart) {
      this.props.navigation.setParams({
        gradStart: storeData.gradStart
      });
    }
    if (storeData.gradEnd) {
      this.props.navigation.setParams({
        gradEnd: storeData.gradEnd
      });
    }

    Moment.locale('en');

    this.setState({ orderId, storeData }, () => {
      this.fetchData(storeData.id, orderId)
      this.setHeaderButtons()
    });

    this.ShipServiceRef = this.updateRef.bind(this, 'ShipService');
    this.ShipTrackingRef = this.updateRef.bind(this, 'ShipTracking');
    this.DeliveredToRef = this.updateRef.bind(this, 'DeliveredTo');
    this.PaymentRefRef = this.updateRef.bind(this, 'PaymentRef');
    this.CancelReasonRef = this.updateRef.bind(this, 'CancelReason');
    this.CompletionNotesRef = this.updateRef.bind(this, 'CompletionNotes');
    this.FeedbackRef = this.updateRef.bind(this, 'Feedback');
  }

  fetchData(storeId, orderId) {

    this.unsubscribe = firebase.firestore().collection('mystore').doc(storeId).collection('orders').doc(orderId).onSnapshot((orderDetails) => {

      let CustomerName = orderDetails.data().CustomerName;
      CustomerName = CustomerName ? CustomerName : 'Guest';
      let CustomerId = orderDetails.data().CustomerId;
      let PlacedAt = orderDetails.data().PlacedAt.toMillis();
      let PymntStatus = orderDetails.data().PymntStatus;
      PymntStatus = PymntStatus ? true : false;
      let OrderStatus = orderDetails.data().Status;
      //this.props.navigation.setParams({ OrderStatus: OrderStatus });
      let totalPayable = orderDetails.data().AmountPayable;
      let totalPayableWithoutDelivery = orderDetails.data().TotalPayableWithoutDelivery
      let total = orderDetails.data().Amount;
      let discount = orderDetails.data().Discount;
      let pendingAcceptance = orderDetails.data().pendingAcceptance == undefined ? false : orderDetails.data().pendingAcceptance;
      let Accepted = orderDetails.data().pendingAcceptance == undefined ? true : orderDetails.data().Accepted == undefined ? false : orderDetails.data().Accepted;
      let deliverySlot = orderDetails.data().deliverySlot == undefined ? '' : orderDetails.data().deliverySlot

      //this.props.navigation.setParams({ Accepted: Accepted, pendingAcceptance: pendingAcceptance });

      let DeclineReason = orderDetails.data().DeclineReason;
      let CancelReason = orderDetails.data().CancelReason;
      switch (OrderStatus) {
        case 'Pending':
        case 'Placed':
          this.setState({ currentPosition: 1 });
          break;
        case 'In Process':
          this.setState({ currentPosition: 1 });
          break;
        case 'Dispatched':
          this.setState({ currentPosition: 2 });
          break;
        case 'Delivered':
          this.setState({ currentPosition: 3 });
          break;
        case 'Complete':
          this.setState({ currentPosition: 4 });
          break;

      };
      this.setState({ OrderStatus, CustomerName, PlacedAt, PymntStatus, CustomerId, totalPayable, totalPayableWithoutDelivery, total, discount, pendingAcceptance, Accepted, DeclineReason, CancelReason, OrderDetails: orderDetails.data(), Coupon: orderDetails.data().Coupon, DeliveryCharge: orderDetails.data().DeliveryCharge ? orderDetails.data().DeliveryCharge : 0, deliverySlot }, () => this._getCustomerAddress());
      this.items = firebase.firestore().collection('mystore').doc(storeId).collection('orders').doc(orderId).collection('items');
      this.items.get().then((querySnapshot) => this.onCollectionUpdate(querySnapshot));
    });
  }


  componentWillUnmount() {
    this.unsubscribe ? this.unsubscribe() : null;
  }

  onCollectionUpdate = (async (querySnapshot) => {
    var itemsList = [];
    var index = 0;
    var html_contents = "";
    var shippingFromhtml = "";


    Promise.all(querySnapshot.docs.map(async doc => {

      itemsList.push({
        id: doc.id,
        index: index++,
        ItemName: doc.data().ItemName,
        ItemId: doc.data().ItemId,
        variant: doc.data().VariantId,
        Qty: doc.data().Qty,
        Color: doc.data().Color,
        Size: doc.data().Size,
        Packing: doc.data().Packing,
        Material: doc.data().Material,
        Other: doc.data().Other,
        SellingPrice: doc.data().SellingPrice,
        DiscountPrice: doc.data().DiscountPrice,
        MRP: doc.data().MRP,
        starCount: doc.data().starCount ? doc.data().starCount : 3.5,
        Feedback: doc.data().Feedback ? doc.data().Feedback : ""
      });
      var htmlpriceitem = doc.data().DiscountPrice > 0 ? this.state.storeData.Currency + (doc.data().DiscountPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : this.state.storeData.Currency + (doc.data().SellingPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      var htmlprice = doc.data().DiscountPrice > 0 ? this.state.storeData.Currency + (doc.data().DiscountPrice * doc.data().Qty).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : this.state.storeData.Currency + (doc.data().SellingPrice * doc.data().Qty).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      html_contents = html_contents + '<tr class="item"><td>' + doc.data().ItemName + '</td><td>' + htmlpriceitem + '</td><td align="center">' + doc.data().Qty + '</td><td align="right">' + htmlprice + '</td></tr>';

      let price = doc.data().DiscountPrice > 0 ? doc.data().DiscountPrice : doc.data().SellingPrice;
      //this.setState({total:this.state.total+(price*doc.data().Qty)});



    })).then(() => {
      if (itemsList.length == 0) {
        this.setState({ emptyCart: true });
      }

      shippingFromhtml = '<h4 class="mb-0">' + this.state.storeData.storeName + '</h4>';
      shippingFromhtml += '<p class="card-text mb-auto">' + this.state.storeData.address + '</p>';
      shippingFromhtml += '<p class="card-text mb-auto">' + this.state.storeData.city + ', ' + this.state.storeData.stat + '</p>';
      shippingFromhtml += '<p class="card-text mb-auto">' + this.state.storeData.country + (this.state.storeData.postal ? ' - ' + this.state.storeData.postal : '') + '</p>';
      var storePhone = (this.state.storeData.loginPhone ? this.state.storeData.loginPhone : this.state.storeData.phone ? '+' + this.state.storeData.countrycode + this.state.storeData.phone : '');
      shippingFromhtml += storePhone ? '<p class="card-text mb-auto">Ph:' + storePhone + '</p>' : '';
      var html = '<!doctype html><html><head>    <meta charset="utf-8">    <title>Invoice</title>    <style>    .invoice-box {        max-width: 800px;        margin: auto;        padding: 30px;        border: 1px solid #eee;        box-shadow: 0 0 10px rgba(0, 0, 0, .15);        font-size: 16px;        line-height: 24px;        font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;        color: #555;    }    .invoice-box table {        width: 100%;        line-height: inherit;        text-align: left;    }    .invoice-box table td {        vertical-align: top;    }    .invoice-box table tr td:nth-child(2) {        text-align: right;    }    .invoice-box table tr.top table td.title {        font-size: 45px;        line-height: 45px;        color: #333;    }    .invoice-box table tr.information table td {        padding-bottom: 20px;    }    .invoice-box table tr.heading td {        background: #eee;        border-bottom: 1px solid #ddd;        font-weight: bold;    }    .invoice-box table tr.details td {        padding-bottom: 20px;    }    .invoice-box table tr.item td{        border-bottom: 1px solid #eee;    }    .invoice-box table tr.item.last td {        border-bottom: none;    }    .invoice-box table tr.total td:nth-child(2) {        border-top: 2px solid #eee;        font-weight: bold;    }    @media only screen and (max-width: 600px) {        .invoice-box table tr.top table td {            width: 100%;            display: block;            text-align: center;        }        .invoice-box table tr.information table td {            width: 100%;            display: block;            text-align: center;        }    }    /** RTL **/    .rtl {        direction: rtl;        font-family: Tahoma, "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;    }    .rtl table {        text-align: right;    }    .rtl table tr td:nth-child(2) {        text-align: left;    }    </style></head><body>    <div class="invoice-box">        <table cellpadding="0" cellspacing="0">            <tr class="top">                <td colspan="4">';
      html += '<table><tr>';
      //Logo
      html += '<td class="title"><img src="' + this.state.storeData.image + '" style="width:25%; max-width:300px;"></td>';
      html += '<td>Invoice #: ' + this.state.PlacedAt.toString().slice(-4) + '<br>Order Date: ' + Moment(this.state.PlacedAt).format('DD-MMM-YYYY') + '</td></tr></table></td></tr><tr class="information"><td colspan="4"><table><tr>';
      html += '<td>' + this.state.storeData.storeName + '<br>' + this.state.storeData.address + '<br>' + this.state.storeData.city + ', ' + this.state.storeData.stat + '<br>' + this.state.storeData.country + (this.state.storeData.postal ? ' - ' + this.state.storeData.postal : '') + '</td>';

      var htmlend = '</table><table><tr><th>Name</th><th align="right">Amount</th><th align="center">Quantity</th><th align="right">Total</th></tr>';
      htmlend += html_contents;
      this.state.discount > 0 ? htmlend += '<tr><td></td><td></td><td></td><td>Discount: ' + (this.state.storeData.Currency + (this.state.discount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + '</td>            </tr>' : null;
      this.state.DeliveryCharge > 0 ? htmlend += '<tr><td></td><td></td><td></td><td>Delivery Charge: ' + (this.state.storeData.Currency + (this.state.DeliveryCharge).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + '</td>            </tr>' : null;
      htmlend += '<tr><td></td><td></td><td></td><td>Total: ' + (this.state.storeData.Currency + (this.state.totalPayable).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")) + '</td>            </tr>        </table>'
      htmlend += `<table>
      <tr>
      <td>
      <div>
      Scan for Order status
      and Payment
      <br/>
      <img id="barcode"               src="https://api.qrserver.com/v1/create-qr-code/?data=https://storemystore.vercel.app/?s=`+ this.state.storeId + '%26o=' + this.state.orderId + `&amp;size=100x100"               alt=""               title="Store My Store"               width="100"               height="100" />
      </div>
      </td>
      <td>
      <br/>
      <br/>
      <br/>
      <br/>
      <a href="https://www.storemystore.com/business/">
      <img src="https://firebasestorage.googleapis.com/v0/b/vyapar-myhomestore.appspot.com/o/powered_by.png?alt=media&token=42101ec9-38bc-439e-a0f3-b165735f68b6" style="width:150px; border-radius:5px;">
      </a>
      </td>
      </tr>
    </table>
    This is a system generated invoice and does not require a signature`
      htmlend += '</div></body></html>';
      this.setState({
        itemsList,
        isLoading: false,
        html,
        htmlend,
        shippingFromhtml
      });
      //this.props.navigation.setParams({ html });
    });
  });


  render() {

    if (this.state.isLoading) {
      return (<CLoading gradStart={this.state.gradStart} gradEnd={this.state.gradEnd} message={this.state.printing ? 'Printing...' : null} />);
    } else {
      return (
        <View style={styles.container} >
          <View style={{ flex: 1, backgroundColor: '#ffffff' }}>
            {!this.state.emptyCart ? <Card style={{ padding: 5, height: 50, alignSelf: "stretch", flexDirection: "row", justifyContent: "space-between" }}>

              <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems:'center' }}>
                <View style={{ flexDirection: 'row', marginTop: 5, alignItems:'center' }}>
                  <Text style={{ fontSize: 10, fontWeight: 'bold', color: this.state.gradStart }}>Order Id: </Text>
                  <Text style={{ fontSize: 25, fontWeight: 'bold', color: this.state.gradStart }}>{this.state.PlacedAt.toString().slice(-4)}</Text>
                  <TouchableOpacity style={{ marginLeft: 10, backgroundColor: 'grey', borderRadius: 5, paddingHorizontal: 10,paddingVertical:5, height:15, alignItems:'center', justifyContent:'center' }}
                    onPress={() => this._displayOrderInfo()}>
                    <Text style={{ color: 'white' }}>View Details</Text>
                  </TouchableOpacity>
                </View>
                {/* <TouchableOpacity style={{ padding: 10, paddingRight: 20, paddingLeft: 20 }}
                  onPress={() => this._displayOrderInfo()}>
                  <Ionicons name={Platform.OS === "ios" ? "ios-information-circle" : "md-information-circle"} size={20} color={this.state.gradStart}
                  /></TouchableOpacity> */}
                <View style={{ marginRight: 5 }}>
                  <Text >{this.state.storeData.Currency + (this.state.totalPayable).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
                  {//<TouchableOpacity style={{padding:5}} onPress={()=>this._onStepClick(-1)}>
                  }
                  <Text style={{ color: this.state.PymntStatus ? Colors.green : Colors.red }}>{this.state.PymntStatus ? 'Paid' : 'Pending Payment'}</Text>
                  {//</TouchableOpacity>
                  }
                </View>
              </View>

            </Card> : null}
            {this.state.emptyCart ? <Image source={require('../assets/images/emptycart.gif')} style={{ alignSelf: "center" }} /> : null}
            <View style={{ flex: 1, minHeight: 1, minWidth: 1 }}>

              <FlatList
                data={this.state.itemsList}
                renderItem={({ item }) => (
                  <CellContainer style={styles.containerGridFull}>
                    <TouchableOpacity style={{ flex: 1, alignSelf: 'stretch' }} onPress={() => {

                      this.props.navigation.navigate('ItemDetailsScreen', { StoreData: this.state.storeData, ItemId: item.ItemId, ItemName: item.ItemName, gradStart: this.state.gradStart, gradEnd: this.state.gradEnd, Size: item.Size, Color: item.Color, Material: item.Material, Packing: item.Packing, Other: item.Other });

                    }}>
                      <Card style={{ flex: 1 }} >
                        <View style={{ flex: 1, flexDirection: 'row' }}>

                          <View style={{ flex: 1, marginLeft: 5, marginRight: 5 }}>

                            <Text style={{ fontWeight: 'bold', color: 'black', fontSize: 12 }} numberOfLines={2} ellipsizeMode='tail'>{item.ItemName}</Text>
                            <View style={{ flexDirection: 'row', martginTop: 15, justifyContent: 'space-between' }}>
                              <View style={{ flexDirection: 'row' }}>
                                {item.Size ? <Text style={{ marginLeft: 10, color: this.state.gradStart, fontStyle: 'italic', fontSize: 12 }}>{item.Size}</Text> : null}
                                {item.Color ? <Text style={{ marginLeft: 10, color: this.state.gradStart, fontStyle: 'italic', fontSize: 12 }}>{item.Color}</Text> : null}
                                {item.Material ? <Text style={{ marginLeft: 10, color: this.state.gradStart, fontStyle: 'italic', fontSize: 12 }}>{item.Material}</Text> : null}
                                {item.Packing ? <Text style={{ marginLeft: 10, color: this.state.gradStart, fontStyle: 'italic', fontSize: 12 }}>{item.Packing}</Text> : null}
                                {item.Other ? <Text style={{ marginLeft: 10, color: this.state.gradStart, fontStyle: 'italic', fontSize: 12 }}>{item.Other}</Text> : null}
                              </View>

                            </View>

                            <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                              <View style={{ flexDirection: 'row', marginLeft: 10, marginRight: 10 }}>
                                <Text style={{ fontSize: 10 }}>Quantity:</Text>
                                <Text style={{ color: this.state.gradEnd, fontWeight: 'bold', marginLeft: 5, fontSize: 12 }}>{item.Qty}</Text>
                              </View>
                              <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                {item.DiscountPrice > 0 ?
                                  <Text style={Cstyles.mrp}>{item.MRP > item.DiscountPrice ? this.state.storeData.Currency + item.MRP : null}</Text>
                                  : <Text style={Cstyles.mrp}>{item.MRP > item.SellingPrice ? this.state.storeData.Currency + item.MRP : null}</Text>
                                }
                                {item.DiscountPrice > 0 ?
                                  <Text style={Cstyles.off}>{item.MRP > item.DiscountPrice ? (((item.MRP - item.DiscountPrice) / item.MRP) * 100).toFixed(0).toString() + '% off ' : null}</Text>
                                  : <Text style={Cstyles.off}>{item.MRP > item.SellingPrice ? (((item.MRP - item.SellingPrice) / item.MRP) * 100).toFixed(0).toString() + '% off ' : null}</Text>
                                }
                                <Text style={[Cstyles.sellingPrice, { color: this.state.gradStart, marginright: 10 }]}>{item.DiscountPrice > 0 ? this.state.storeData.Currency + (item.DiscountPrice * item.Qty).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null}{item.DiscountPrice <= 0 ? this.state.storeData.Currency + (item.SellingPrice * item.Qty).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null}</Text>

                              </View>
                              {/* {this.state.OrderStatus == 'Complete' ? 
                              <View style={{ alignItems: 'stretch', justifyContent: 'flex-end', marginRight: 10, padding: 10 }}>
                                
                                <StarRating
                                  disabled={false}
                                  maxStars={5}
                                  starSize={25}
                                  rating={item.starCount}
                                  selectedStar={(rating) => this.onStarRatingPress(rating, item)}
                                  fullStarColor='orange'
                                /> 
                              </View> 
                              : null} */}

                            </View>

                          </View>
                        </View>
                      </Card>
                    </TouchableOpacity>
                  </CellContainer>

                )}
                keyExtractor={item => item.ItemId}
              />
            </View>
            <View style={{ alignSelf: 'stretch', alignItems: 'center', borderTopColor: '#999999', borderTopWidth: 2, padding: 5, flexDirection: 'row', justifyContent: 'space-between' }}>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Text style={{ color: 'grey' }}>Delivery Charges: </Text>
                <Text style={{ color: this.state.gradStart, fontSize: 18, fontWeight: 'bold' }}>{this.state.storeData.Currency + this.state.DeliveryCharge.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
              </View>
              <Text style={{ color: this.state.gradStart, fontSize: 18 }}> + </Text>
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <Text style={{ color: 'grey' }}>Item Total: </Text>
                <Text style={{ color: this.state.gradStart, fontSize: 18, fontWeight: 'bold' }}>{this.state.storeData.Currency + this.state.totalPayableWithoutDelivery.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
              </View>
            </View>

            {!this.state.emptyCart ?
              this.state.OrderStatus == 'Cancelled' ?
                <View style={{ alignSelf: 'stretch', justifyContent: 'center', borderTopColor: '#999999', borderTopWidth: 2, padding: 10 }}>
                  <View style={{ alignSelf: 'stretch', alignItems: 'center' }}><Text style={{ color: 'red', fontSize: 20 }}>Cancelled</Text></View>
                  <View style={{ alignSelf: 'stretch', alignItems: 'center' }}><Text style={{ marginLeft: 10 }}>{this.state.CancelReason}</Text></View>
                </View>
                :
                this.state.pendingAcceptance ?
                  <View style={{ alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'space-around', borderTopColor: '#999999', borderTopWidth: 2, padding: 5 }}>
                    <Text style={{ color: 'orange', fontSize: 20 }}>Awaiting store confirmation</Text>
                  </View>
                  : this.state.Accepted ?
                    <View style={{ borderTopColor: '#999999', borderTopWidth: 2, paddingTop: 5 }}>
                      {this.state.DialogLoading ? <ActivityIndicator color={this.state.gradStart} animating size="large" /> :
                        <StepIndicator
                          customStyles={this.customStyles}
                          currentPosition={this.state.currentPosition}
                          labels={this.state.pickUp ? this.state.labels : this.labels}
                          onPress={(pos) => this._onStepClick(pos)}
                        />}

                    </View>


                    :
                    <View style={{ alignSelf: 'stretch', justifyContent: 'center', borderTopColor: '#999999', borderTopWidth: 2, padding: 10 }}>
                      <View style={{ alignSelf: 'stretch', alignItems: 'center' }}><Text style={{ color: 'red', fontSize: 20 }}>Declined</Text></View>
                      <View style={{ alignSelf: 'stretch', alignItems: 'center' }}><Text style={{ marginLeft: 10 }}>{this.state.DeclineReason}</Text></View>
                    </View>
              : null}
          </View>

          <Dialog
            visible={this.state.Dialogvisible}
            dialogAnimation={new SlideAnimation({
              slideFrom: 'bottom',
            })}
            dialogTitle={<DialogTitle title={this.state.DialogTitle} />}

          >
            <DialogContent>
              {this.state.DialogContent == 'Dispatch' ? this._dispatch() : null}
              {this.state.DialogContent == 'Deliver' ? this._deliver() : null}
              {this.state.DialogContent == 'Complete' ? this._complete() : null}
              {this.state.DialogContent == 'Payment' ? this._payment() : null}
              {this.state.DialogContent == 'Rating' ? this._ratingDialog() : null}
              {this.state.DialogContent == 'OrderInfo' ? this._orderInfoDialog() : null}
              {this.state.DialogContent == 'Decline' ? this._decline() : null}
              {this.state.DialogContent == 'Cancel' ? this._cancel() : null}
              <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                {this.state.DialogUpdButton ? <Text style={{ color: Colors.green, fontSize: 20, marginTop: 20, textAlign: 'center' }} onPress={() => this._dialogUpdate()}>{this.state.DialogUpdButtonText}</Text> : null}
                <Text style={{ color: Colors.red, fontSize: 20, marginTop: 20, textAlign: 'center' }} onPress={() => this.CancelDialog()}>Close</Text>
              </View>
            </DialogContent>
          </Dialog>
          {this.state.PymntStatus || this.state.OrderStatus == 'Cancelled' || this.state.Accepted == false ? null :
            <FAB
              label={'Pay Now'}
              style={{
                position: 'absolute',
                margin: 16,
                right: 0,
                bottom: 80
              }}
              small
              color={'white'}
              icon="credit-card"
              theme={{ colors: { accent: this.state.gradStart } }}
              onPress={() => { this.makePayment() }}
            />}
        </View>
      );
    }

  }


  _onStepClick(pos) {

    switch (pos) {
      case -1:
        this.setState({ DialogLoading: true });
        if (this.state.currentPosition >= pos) {
          this.setState({ DialogContent: 'Payment', DialogTitle: 'Payment Details', DialogUpdButtonText: 'Update Payment' });
          firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).get().then((doc) => {
            this.setState({ PaymentDttm: doc.data().PaymentDttm ? Moment(doc.data().PaymentDttm.toDate()).format('MMMM Do YYYY, h:mm:ss a') : '---', PaymentRef: doc.data().PaymentRef ? doc.data().PaymentRef : '---', DialogUpdButton: false }, this.ShowDialog());

          });
        } else {
          this.setState({ DialogContent: 'Payment', DialogTitle: 'Payment Details', DialogUpdButtonText: 'Confirm Payment', PaymentRef: '---', DialogUpdButton: false });
          this.ShowDialog();
        }
        break;
      case 2:
        this.setState({ DialogLoading: true });
        if (this.state.currentPosition >= pos) {
          this.setState({ DialogContent: 'Dispatch', DialogTitle: this.state.pickUp ? 'Order Status' : 'Shipping Details', DialogUpdButtonText: 'Update Dispatch' });
          firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).get().then((doc) => {
            this.setState({ DispDttm: doc.data().DispDttm ? Moment(doc.data().DispDttm.toDate()).format('MMMM Do YYYY, h:mm:ss a') : '---', ShipService: doc.data().ShipService ? doc.data().ShipService : '---', ShipTracking: doc.data().ShipTracking ? doc.data().ShipTracking : '---' }, this.ShowDialog());

          });
        } else {
          this.setState({ DialogContent: 'Dispatch', DialogTitle: this.state.pickUp ? 'Order Status' : 'Dispatch Details', DialogUpdButtonText: 'Confirm Dispatch', ShipService: '---', ShipTracking: '---', DialogUpdButton: false });
          this.ShowDialog();
        }
        break;
      case 3:
        this.setState({ DialogLoading: true });
        if (this.state.currentPosition >= pos) {
          this.setState({ DialogContent: 'Deliver', DialogTitle: 'Delivery Details', DialogUpdButtonText: 'Update Delivery', DialogUpdButton: false });
          firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).get().then((doc) => {
            this.setState({ DeliveredDttm: doc.data().DeliveredDttm ? Moment(doc.data().DeliveredDttm.toDate()).format('MMMM Do YYYY, h:mm:ss a') : '---', DeliveredTo: doc.data().DeliveredTo ? doc.data().DeliveredTo : '---', DialogUpdButton: false }, this.ShowDialog());

          });
        } else {
          this.setState({ DialogContent: 'Deliver', DialogTitle: 'Delivery Details', DialogUpdButtonText: 'Confirm Delivery', DeliveredTo: '---', DialogUpdButton: false });
          this.ShowDialog();
        }
        break;
      case 4:

        this.setState({ DialogLoading: true });

        this.setState({ DialogContent: 'Complete', DialogTitle: 'Complete Order', DialogUpdButtonText: 'Mark Completed', DialogUpdButton: false });
        firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId).get().then((doc) => {
          this.setState({ CompletedDttm: doc.data().CompletedDttm ? Moment(doc.data().CompletedDttm.toDate()).format('MMMM Do YYYY, h:mm:ss a') : '---', CompletionNotes: doc.data().CompletionNotes ? doc.data().CompletionNotes : '---', PymntStatus: doc.data().PymntStatus, PaymentDttm: doc.data().PaymentDttm ? Moment(doc.data().PaymentDttm.toDate()).format('MMMM Do YYYY, h:mm:ss a') : '---', PaymentRef: doc.data().PaymentRef ? doc.data().PaymentRef : '---', DialogUpdButton: false }, this.ShowDialog());

        });

        break;
    }
  }

  _displayOrderInfo() {
    this.setState({ DialogContent: 'OrderInfo', DialogTitle: 'Order Information', DialogUpdButton: false });
    this.ShowDialog();

  }

  _dispatch() {
    if (this.state.pickUp) {
      return (
        <View style={{ width: this.state.scrWidth }}>
          <Text style={{ fontStyle: 'italic', color: Colors.grey }}>{this.state.DispDttm}</Text>
          <Text style={{ marginTop: 10, textAlign: 'center', color: this.state.gradStart }}>{this.state.currentPosition >= 2 ? 'Your order is ready to be picked up from the Store' : 'Your order is not ready for pickup yet'}</Text>
        </View>

      );
    } else {
      return (
        <View style={{ width: this.state.scrWidth }}>
          <Text style={{ fontStyle: 'italic', color: Colors.grey }}>{this.state.DispDttm}</Text>
          <TextInput
            mode='outlined'
            label='Shipped Through'
            ref={this.ShipServiceRef}
            value={this.state.ShipService}
            error={this.state.errors.ShipService}
            style={{ width: this.state.scrWidth }}
            disabled={true}
            onChangeText={(text) => this.updateTextInput(text, 'ShipService')}
          />
          <TextInput
            mode='outlined'
            label='Tracking Id'
            ref={this.ShipTrackingRef}
            value={this.state.ShipTracking}
            error={this.state.errors.ShipTracking}
            style={{ width: this.state.scrWidth }}
            disabled={true}
            onChangeText={(text) => this.updateTextInput(text, 'ShipTracking')}
          />

          {this.state.ShipService == 'Shiprocket' && this.state.ShipTracking ?
            <TouchableOpacity style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'center', padding: 10 }} onPress={() => window.open('https://shiprocket.co/tracking/' + this.state.ShipTracking)}>
              <Text style={{ textDecorationLine: 'underline', textAlign: 'center', fontSize: 16, marginRight: 5 }}>Track shipment</Text>
              <FontAwesome name='external-link' color={this.state.gradStart} size={20} />
            </TouchableOpacity>
            : null}
        </View>

      );
    }

  }



  _updateCancel() {

    this._restoreStock('cancel');

  }

  _restoreStock(source) {
    var batch = firebase.firestore().batch();
    this.state.itemsList.map(listItem => {
      if (listItem.variant != 0) {
        batch.update(firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('items').doc(listItem.ItemId).collection("variants").doc(listItem.variant), { Stock: firebase.firestore.FieldValue.increment((listItem.Qty)) });
      } else {
        batch.update(firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('items').doc(listItem.ItemId), { Stock: firebase.firestore.FieldValue.increment((listItem.Qty)) });
      }
    });
    batch.update(firebase.firestore().collection('mystore').doc(this.state.storeData.id).collection('orders').doc(this.state.orderId), { Status: 'Cancelled', CancelledDttm: firebase.firestore.FieldValue.serverTimestamp(), UpdateDttm: firebase.firestore.FieldValue.serverTimestamp(), CancelReason: this.state.CancelReason ? this.state.CancelReason : '', Completed: true });
    batch.commit().then(() => {
      this.setState({ Status: 'Cancelled', OrderStatus: 'Cancelled' });
      //this.props.navigation.setParams({ OrderStatus: 'Cancelled', pendingAcceptance: false, Accepted: false });
      sendPushNotif(this.state.storeData.pushToken, 'Order Cancelled', 'Order ' + this.state.PlacedAt.toString().slice(-4) + ' has been cancelled by the customer', this.state.orderId, this.state.profile_data.uid, 'New Order');

    });


  }

  _complete() {
    return (
      <View style={{ width: this.state.scrWidth }}>
        <Text style={{ fontStyle: 'italic', color: Colors.grey }}>{this.state.CompletedDttm}</Text>
        <Checkbox title='Payment Received'
          disabled={true}
          checked={!!this.state.PymntStatus}
        />
        <TextInput
          mode='outlined'
          label='Payment Reference'
          ref={this.PaymentRefRef}
          value={this.state.PaymentRef}
          error={this.state.errors.PaymentRef}
          style={{ width: this.state.scrWidth }}
          disabled={true}
          onChangeText={(text) => this.updateTextInput(text, 'PaymentRef')}
        />
        <TextInput
          mode='outlined'
          label='Notes'
          ref={this.CompletionNotesRef}
          value={this.state.CompletionNotes}
          error={this.state.errors.CompletionNotes}
          style={{ width: this.state.scrWidth }}
          disabled={true}
          onChangeText={(text) => this.updateTextInput(text, 'CompletionNotes')}
        />
      </View>

    );

  }

  _payment() {
    return (
      <View style={{ width: this.state.scrWidth }}>
        <Text style={{ fontStyle: 'italic', color: Colors.grey }}>{this.state.PaymentDttm}</Text>
        <Checkbox title='Payment Received'
          disabled={true}
          checked={!!this.state.PymntStatus}
        />
        <TextInput
          mode='outlined'
          label='Payment Reference'
          ref={this.PaymentRefRef}
          value={this.state.PaymentRef}
          error={this.state.errors.PaymentRef}
          style={{ width: this.state.scrWidth }}
          disabled={true}
          onChangeText={(text) => this.updateTextInput(text, 'PaymentRef')}
        />
      </View>

    );

  }

  _getCustomerAddress() {
    let DName = '', DAddress = '', DCityStat = '', DCountryPostal = '', DPhone = '', custhtml = '', shippingTohtml = '';
    if (this.state.OrderDetails.DName) {
      DName = this.state.OrderDetails.DName;
      DAddress = this.state.OrderDetails.DAddress;
      DCityStat = (this.state.OrderDetails.DCity ? this.state.OrderDetails.DCity : '') + (this.state.OrderDetails.DStat ? ', ' + this.state.OrderDetails.DStat : '');
      DCountryPostal = this.state.OrderDetails.DPostal + ' ' + this.state.OrderDetails.DCountry;
      DPhone = this.state.OrderDetails.DPhone ? 'Ph: ' + this.state.OrderDetails.DPhone : '';
    }

    custhtml = '<td>' + DName + '<br>' + DAddress + '<br>' + DCityStat + '<br>' + DCountryPostal + '</td></tr></table></td></tr>';
    shippingTohtml = '<h4 class="mb-0">' + DName + '</h4>';
    shippingTohtml += '<p class="card-text mb-auto">' + DAddress + '</p>';
    shippingTohtml += '<p class="card-text mb-auto">' + DCityStat + '</p>';
    shippingTohtml += '<p class="card-text mb-auto">' + DCountryPostal + '</p>';
    shippingTohtml += '<p class="card-text mb-auto">' + DPhone + '</p>';

    this.setState({ CustomerName: DName, DName, DAddress, DCityStat, DCountryPostal, DPhone, custhtml, shippingTohtml });

  }

  _orderInfoDialog() {

    return (
      <View style={{ width: this.state.scrWidth }}>
        {this.state.discount ?
          <View>
            <View style={{ alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ color: this.state.gradStart }}>Discount availed</Text>
              <Text>{this.state.storeData.Currency + (this.state.discount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
            </View>
            <View style={{ alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text style={{ color: this.state.gradStart }}>Coupon Code</Text>
              <Text>{this.state.Coupon}</Text>
            </View>
          </View>
          : null}
        {this.state.DeliveryCharge ?
          <View style={{ alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'space-between' }}>
            <Text style={{ color: this.state.gradStart }}>Delivery Charge</Text>
            <Text>{this.state.storeData.Currency + this.state.DeliveryCharge.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>
          </View>
          : null}
        <View style={{ alignSelf: 'stretch', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text style={{ color: this.state.gradStart }}>Final order value</Text>
          <Text>{this.state.storeData.Currency + (this.state.totalPayable).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</Text>

        </View>

        <Text style={{ marginTop: 20, fontSize: 16, fontStyle: 'italic', color: this.state.gradStart }}>Deliver to</Text>
        {this.state.DName ?
          <View><Text>{this.state.DName}</Text>
            <Text>{this.state.DAddress}</Text>
            <Text>{this.state.DCityStat}</Text>
            <Text>{this.state.DCountryPostal}</Text>
            <Text>{this.state.DPhone}</Text>


          </View>

          :
          <Text>Delivery information unavailable</Text>
        }
        {this.state.deliverySlot ?
          <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <FontAwesome name={'clock-o'} color={this.state.gradStart} size={16} />
            <Text style={{ marginLeft: 5 }}>{this.state.deliverySlot}</Text>
          </View>
          : <View></View>}

      </View>);

  }
  _ratingDialog() {

    return (
      <View style={{ width: this.state.scrWidth }}>
        <Text>{'Please help us with your feedback for ' + this.state.RatingItem}</Text>
        <TextInput
          mode='outlined'
          label='Feedback'
          ref={this.FeedbackRef}
          value={this.state.Feedback}
          error={this.state.errors.Feedback}
          style={{ width: this.state.scrWidth }}
          disabled={false}
          onChangeText={(text) => this.updateTextInput(text, 'Feedback')}
        />
      </View>

    );

  }

  _cancel() {
    return (
      <View style={{ width: this.state.scrWidth }}>

        <TextInput
          mode='outlined'
          label='Cancellation Reason'
          ref={this.CancelReasonRef}
          value={this.state.CancelReason}
          error={this.state.errors.CancelReason}
          style={{ width: this.state.scrWidth }}
          onChangeText={(text) => this.updateTextInput(text, 'CancelReason')}
        />
      </View>

    );

  }

  _deliver() {
    return (
      <View style={{ width: this.state.scrWidth }}>
        <Text style={{ fontStyle: 'italic', color: Colors.grey }}>{this.state.DeliveredDttm}</Text>
        <TextInput
          mode='outlined'
          label='Delivered To'
          ref={this.DeliveredToRef}
          value={this.state.DeliveredTo}
          error={this.state.errors.DeliveredTo}
          style={{ width: this.state.scrWidth }}
          disabled={true}
          onChangeText={(text) => this.updateTextInput(text, 'DeliveredTo')}
        />
      </View>

    );

  }

  _dialogUpdate() {
    this.setState({ DialogLoading: true });
    this.HideDialog();
    switch (this.state.DialogContent) {
      case 'Cancel':
        this._updateCancel();
        break;
      case 'Rating':
        this._updateRating();
        break;
    }
  }


  updateRef(name, ref) {
    this[name] = ref;
  }


  updateTextInput = (text, field) => {
    const state = this.state
    state[field] = text;
    this.setState(state);
  }

  ShowDialog() {
    this.setState({ Dialogvisible: true });
  }

  HideDialog() {
    this.setState({ Dialogvisible: false, DialogUpdButton: false });

  }

  CancelDialog() {
    this.setState({ Dialogvisible: false, DialogLoading: false, DialogUpdButton: true });

  }

  get gradient() {
    return (
      <LinearGradient
        colors={[this.state.gradStart, this.state.gradEnd]}
        startPoint={{ x: 1, y: 0 }}
        endPoint={{ x: 0, y: 1 }}
        style={styles.gradient}
      />
    );
  }





  _maybeRenderImage = (image) => {
    //let { image } = this.state;
    if (!image) {
      return;
    }

    return (

      <View
        style={{
          borderRadius: 4,
          marginTop: 2,
          shadowColor: 'rgba(0,0,0,1)',
          shadowOpacity: 0.2,
          shadowOffset: { width: 4, height: 4 },
          shadowRadius: 5,
          overflow: 'hidden',
        }}>
        <Image source={{ uri: image }} style={{ width: 100, height: 100, borderRadius: 4 }} />
      </View>

    );
  }
}

const styles = {
  container: {
    alignItems: "stretch",
    flex: 1,

  },
  containerGridFull: {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flex: 1,
    flexDirection: 'row',
    backgroundColor: "transparent",
    marginLeft: 5

  },
  gradient: {
    ...StyleSheet.absoluteFillObject
  },
  iconContainer: {
    flexDirection: "row",
    justifyContent: "space-evenly",
    width: 120
  }
};

const mapStateToProps = (state) => {
  const { store, profile_data } = state
  return { store, profile_data }
};
const mapDispatchToProps = dispatch => (
  bindActionCreators({
    updateStore, updateProfile
  }, dispatch)
);
export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);